import { z } from "zod";

export const emailSchema = z.object({
  email: z
    .string()
    .min(1, "Email is required")
    .max(254, "Email must be less than 254 characters")
    .email("Invalid email format")
    .refine(
      (email) => (email.split("@")[0] ?? "").length < 64,
      "Email must be less than 64 characters",
    )
    .refine(
      (email) => (email.split("@")[1] ?? "").length < 63,
      "Domain must be less than 63 characters",
    ),
});
